let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjKdP")).then(() => parcelRequire('5u7tc'));